var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-[8px] space-y-[10px]"},[_c('div',{staticClass:"h-[40px] w-full bg-gray-200 rounded animate-pulse"}),_vm._l((_vm.itemCount),function(n){return _c('div',{key:n,staticClass:"pl-[24px]"},[_c('div',{staticClass:"h-[40px] w-full bg-gray-200 rounded animate-pulse"})])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }